var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReddit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 41.861 41.861"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "reddit_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h41.861v41.861H0z",
  "data-name": "Rectangle 7494"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 18863"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 18704"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#reddit_svg__a)",
  "data-name": "Group 18703"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M33.174 19.99a2.784 2.784 0 0 0-4.692-2.026 12.05 12.05 0 0 0-6.428-2.382l1.425-4.268 3.59 1.8c-.006.067-.017.128-.017.2a1.672 1.672 0 1 0 .512-1.2L23.941 10.3a1.075 1.075 0 0 0-1.5.612L20.9 15.538a12.3 12.3 0 0 0-7.519 2.426 2.783 2.783 0 1 0-2.933 4.614 6 6 0 0 0-.089 1.03c0 4.458 4.736 8.07 10.574 8.07S31.5 28.066 31.5 23.608a5.7 5.7 0 0 0-.089-1.03 2.78 2.78 0 0 0 1.759-2.588m-17.805 2.226a1.67 1.67 0 1 1 1.669 1.67 1.667 1.667 0 0 1-1.669-1.67m9.923 4.759A5.18 5.18 0 0 1 20.93 28.9a5.17 5.17 0 0 1-4.357-1.92.55.55 0 0 1 .15-.768.56.56 0 0 1 .773.15 4.1 4.1 0 0 0 3.434 1.425 4.12 4.12 0 0 0 3.434-1.425.56.56 0 0 1 .774-.145.554.554 0 0 1 .15.763m-.462-3.089a1.669 1.669 0 1 1 1.67-1.67 1.67 1.67 0 0 1-1.67 1.67",
  "data-name": "Path 27246"
}))))));
export { SvgReddit as ReactComponent };
export default __webpack_public_path__ + "static/media/reddit.6c76da6ab031abfc7344f82647efbdad.svg";